import { render } from "./CarRequestForm.vue?vue&type=template&id=270f52cc&scoped=true"
import script from "./CarRequestForm.vue?vue&type=script&lang=js"
export * from "./CarRequestForm.vue?vue&type=script&lang=js"

import "./CarRequestForm.vue?vue&type=style&index=0&id=270f52cc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270f52cc"]])

export default __exports__